var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content" },
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { lg: 24, md: 24 } },
            [
              _c("h1", { staticClass: "title" }, [
                _vm._v("Central do Interessado")
              ]),
              _c("br"),
              _c(
                "el-button",
                {
                  staticClass: "texto-aviso",
                  attrs: { type: "text" },
                  on: { click: _vm.redirect }
                },
                [
                  _c("font-awesome-icon", {
                    staticClass: "icon-aviso",
                    attrs: { icon: "file" }
                  }),
                  _vm._v(
                    "  Verifique os documentos necessários para fazer o cadastro"
                  )
                ],
                1
              ),
              _c("br"),
              _c("p", [
                _vm._v("A"),
                _c("b", [_vm._v(" Central do Interessado")]),
                _vm._v(" " + _vm._s(_vm.CENTRAL_DO_INTERESSADO.DESCRICAO))
              ]),
              _c("p", [
                _c("b", [_vm._v("Central de Mensagens: ")]),
                _vm._v(
                  "fornece meios para o interessado/cadastrante acompanhar o andamento do seu processo,\nrecebendo notificações sobre possíveis pendências ou esclarecimentos identificados no curso da análise."
                )
              ]),
              _c("p", [
                _vm._v(
                  "A Central de Mensagens conta com " +
                    _vm._s(_vm.isIcmBio() || _vm.isRondonia() ? "4" : "5") +
                    " (cinco) funcionalidades:"
                )
              ]),
              _c("div", { staticClass: "funcionalidades" }, [
                _c("p", [
                  _vm._v("1. Acompanhar processos;"),
                  _c("br"),
                  _vm._v(" 2. Visualizar mensagens;"),
                  _c("br"),
                  _vm._v(" 3. Responder mensagens;"),
                  _c("br"),
                  _vm._v(
                    " 4. Receber por e-mail notificações da existência de mensagens na Central do Interessado;"
                  )
                ])
              ]),
              !_vm.isAmapa() && !_vm.isRondonia() && !_vm.isIcmBio()
                ? _c("div", [
                    _c("br"),
                    _vm._v(
                      "5. Gerar declaração de trâmite processual: disponível apenas para processos de regularização fundiária por\nAlienação simples doação"
                    )
                  ])
                : _vm._e(),
              !_vm.isAmapa() && !_vm.isIcmBio()
                ? _c("div", [
                    _c("p", [
                      _c("b", [_vm._v("Cadastros On-line: ")]),
                      _vm._v(
                        _vm._s(
                          _vm.CENTRAL_DO_INTERESSADO.CADASTROS_ONLINE.DESCRICAO
                        )
                      )
                    ]),
                    _c("p", [
                      _vm._v(
                        "Módulo de Cadastro On-line conta com duas ferramentas para a realização do cadastro:"
                      )
                    ]),
                    _c("div", { staticClass: "funcionalidades" }, [
                      _c("p", [
                        _vm._v(
                          "1. Cadastrar: permite ao cadastrante o preenchimento das informações necessárias para a solicitação de regularização de área de interesse e dos demais serviços acima especificados;"
                        ),
                        _c("br"),
                        _vm._v(
                          "2. Enviar cadastro: permite o envio do cadastro para o Módulo Receptor."
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _c("br"),
              _c(
                "el-button",
                {
                  staticClass: "botao",
                  attrs: { type: "primary" },
                  on: { click: _vm.redirectToPortal }
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: "external-link-alt", size: "lg" }
                  }),
                  _c("span", [
                    _c("b", { staticClass: "text-botao" }, [
                      _vm._v("Acessar a Central do Interessado")
                    ])
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0e739e49", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e739e49","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/portal/publico/CentralInteressado.vue
// module id = null
// module chunks = 